import { render, staticRenderFns } from "./form_add.vue?vue&type=template&id=5153db8b&scoped=true"
import script from "./form_add.vue?vue&type=script&lang=js"
export * from "./form_add.vue?vue&type=script&lang=js"
import style0 from "./form_add.vue?vue&type=style&index=0&id=5153db8b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153db8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5153db8b')) {
      api.createRecord('5153db8b', component.options)
    } else {
      api.reload('5153db8b', component.options)
    }
    module.hot.accept("./form_add.vue?vue&type=template&id=5153db8b&scoped=true", function () {
      api.rerender('5153db8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/calculate_salary_date/form/components/form_add.vue"
export default component.exports